import { render, staticRenderFns } from "./VComponent.vue?vue&type=template&id=2a9341f1&"
import script from "./VComponent.vue?vue&type=script&lang=ts&"
export * from "./VComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports